import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {ProfileRoutingModule} from './profile-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {ProfileService} from './profile.service';
import { ProfileAddComponent } from './profile-add/profile-add.component';
import {PostService} from './post/post.service';
import { PostAddComponent } from './post/post-add/post-add.component';
import { PostListComponent } from './post/post-list/post-list.component';
import {ShareModule} from '../share/share.module';
import { ProfileWaitingComponent } from './profile-waiting/profile-waiting.component';
import { ProfilePageComponent } from './profile-page/profile-page.component';
import { CertificateComponent } from './certificate/certificate.component';
import { CertificateWaitingComponent } from './certificate/certificate-waiting/certificate-waiting.component';
import {CertificateService} from './certificate/certificate.service';
import { TrialComponent } from './trial/trial.component';
import { ProfileTrialCheckComponent } from './trial/profile-trial-check/profile-trial-check.component';
import {TrialService} from './trial/trial.service';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import { ProfileMediaProComponent } from './profile-media-pro/profile-media-pro.component';
import { ProfileAuditComponent } from './tiktok/profile-audit/profile-audit.component';
import { ProfileTitleComponent } from './tiktok/profile-title/profile-title.component';
import { ProfileMediaAnalyzeProComponent } from './media/profile-media-analyze-pro/profile-media-analyze-pro.component';
import { ProfileMediaEngageProComponent } from './media/profile-media-engage-pro/profile-media-engage-pro.component';
import {ChartModule} from 'angular-highcharts';
import { ProfileMediaWordRankComponent } from './media/profile-media-word-rank/profile-media-word-rank.component';
import { ProfileMediaHashtagRankComponent } from './media/profile-media-hashtag-rank/profile-media-hashtag-rank.component';
import { ProfileMediaTagRankComponent } from './media/profile-media-tag-rank/profile-media-tag-rank.component';
import { ProfileMediaActivityChartComponent } from './media/profile-media-activity-chart/profile-media-activity-chart.component';
import { ProfileMediaHourChartComponent } from './media/profile-media-hour-chart/profile-media-hour-chart.component';
import { ProfileMediaWeekDayChartComponent } from './media/profile-media-week-day-chart/profile-media-week-day-chart.component';
import { ProfileMediaEngageWeekDayComponent } from './media/profile-media-engage-week-day/profile-media-engage-week-day.component';
import { ProfilePageProComponent } from './profile-page-pro/profile-page-pro.component';
import { ProfileAuditProComponent } from './profile-audit-pro/profile-audit-pro.component';
import {BreadcrumbsComponent} from '../share/breadcrumbs/breadcrumbs.component';
import {ProfileAuditAudienceComponent} from './tiktok/profile-audit-audience/profile-audit-audience.component';
import {ProfileAuditAudienceDemoComponent} from './tiktok/profile-audit-audience-demo/profile-audit-audience-demo.component';


@NgModule({
  declarations: [
    ProfileAddComponent,
    PostAddComponent,
    PostListComponent,
    ProfileWaitingComponent,
    ProfilePageComponent,
    CertificateComponent,
    CertificateWaitingComponent,
    TrialComponent,
    ProfileTrialCheckComponent,
    ProfileMediaProComponent,
    ProfileAuditComponent,
    ProfileTitleComponent,
    ProfileMediaAnalyzeProComponent,
    ProfileMediaEngageProComponent,
    ProfileMediaWordRankComponent,
    ProfileMediaHashtagRankComponent,
    ProfileMediaTagRankComponent,
    ProfileMediaActivityChartComponent,
    ProfileMediaHourChartComponent,
    ProfileMediaWeekDayChartComponent,
    ProfileMediaEngageWeekDayComponent,
    ProfilePageProComponent,
    ProfileAuditAudienceDemoComponent,
    ProfileAuditAudienceComponent
  ],
  imports: [
    ProfileRoutingModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ShareModule,
    NgbModalModule,
    ChartModule,
    BreadcrumbsComponent,
    NgOptimizedImage,
  ],
  exports: [
    ShareModule,
    PostListComponent
  ],
  providers: [
    ProfileService,
    PostService,
    CertificateService,
    TrialService
  ]
})
export class ProfileModule {}
